module.exports = __webpack_public_path__ + "static/continental-ea0e17a5159993e06b33b155426cac81.jpg";